import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Box, 
  Text, 
  IconButton, 
  ActionMenu,
  ActionList,
} from '@primer/react';
import { 
  KebabHorizontalIcon,
  PersonIcon,
  ChevronRightIcon,
  TrashIcon,
  BookIcon,
  TasklistIcon
} from '@primer/octicons-react';
import { useCommonContext } from '../../contexts/common';
import UserAvatar from '../user-avatar';

interface HocSinh {
  id: number;
  ho_ten: string;
  ma_hs: string;
  trang_thai: string;
  dm_gioitinh_id: number;
  gioi_tinh: string;
  ten_he: string;
  ten_lop: string;
}

interface PhuHuynhChildItemProps {
  hocSinh: HocSinh;
  isSelected: boolean;
  onSelected: () => void;
  onDeleted: () => void;
}

const PhuHuynhChildItem: React.FC<PhuHuynhChildItemProps> = ({
  hocSinh,
  isSelected,
  onSelected,
  onDeleted
}) => {
  const { translate } = useCommonContext();

  return (
    <ActionList showDividers>
      <ActionList.GroupHeading>Học sinh</ActionList.GroupHeading>
      <ActionList.Item
        sx={{
          py: 2,
          backgroundColor:'canvas.subtle',
          '&:hover': {
            backgroundColor: 'canvas.subtle',
          },
        }}
        //onClick={onSelected}
      >
        <Box sx={{ display: 'flex', width: '100%' ,mt:2}}>
          {/* Left column for icons */}
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            mr: 2,
            minWidth: '32px'
          }}>
            <Box sx={{ 
              height: '24px', 
              display: 'flex', 
              alignItems: 'center',
              mb: 1
            }}>
              <UserAvatar 
                size="medium"
                fullName={hocSinh.ho_ten}
              />
            </Box>
            <Box sx={{ 
              height: '24px', 
              display: 'flex', 
              alignItems: 'center',
              mb: 1
            }}>
              <PersonIcon size={16} />
            </Box>
            <Box sx={{ 
              height: '24px', 
              display: 'flex', 
              alignItems: 'center',
              mb: 1
            }}>
              <TasklistIcon size={16} />
            </Box>
            <Box sx={{ 
              height: '24px', 
              display: 'flex', 
              alignItems: 'center'
            }}>
              <TasklistIcon size={16} />
            </Box>
          </Box>

          {/* Right column for content */}
          <Box flex={1}>
            {/* Row 1: Name and Status */}
            <Box sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: '24px',
              mb: 1
            }}>
              <Text fontWeight="bold">{hocSinh.ho_ten}</Text>
              <Text 
                as="span"
                sx={{
                  ml: 2,
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  fontSize: 0,
                  backgroundColor: 'sponsors.muted',
                  color: 'sponsors.fg',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}
              >
                {translate(hocSinh.trang_thai)}
              </Text>
            </Box>

            {/* Row 2: Gender */}
            <Box sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: '24px',
              mb: 1
            }}>
              <Text fontSize={1}>{hocSinh.gioi_tinh}</Text>
            </Box>

            {/* Row 3: Student ID and Program */}
            <Box sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: '24px',
              mb: 1
            }}>
              <Text fontSize={1}>{hocSinh.ma_hs} - {hocSinh.ten_he}</Text>
            </Box>

            {/* Row 4: Class */}
            <Box sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: '24px'
            }}>
              <Text fontSize={1}>{hocSinh.ten_lop}</Text>
            </Box>
          </Box>

          {/* Action menu */}
          <Box sx={{ ml: 2 }}>
            <ActionMenu>
              <ActionMenu.Anchor>
                <IconButton
                  icon={KebabHorizontalIcon}
                  aria-label="More options"
                  variant="invisible"
                />
              </ActionMenu.Anchor>
              <ActionMenu.Overlay>
                <ActionList>
                  <ActionList.Item
                    variant="danger"
                    onSelect={onDeleted}
                  >
                    <ActionList.LeadingVisual>
                      <TrashIcon />
                    </ActionList.LeadingVisual>
                    Xóa
                  </ActionList.Item>
                </ActionList>
              </ActionMenu.Overlay>
            </ActionMenu>
          </Box>
        </Box>
      </ActionList.Item>
    </ActionList>
  );
};

export default PhuHuynhChildItem;